import { useEffect, useState } from "react";
import { Button, Col, Form, Input, Modal, Row, Select, Typography } from "antd";
import { callUpdateStatusLotto } from "../../../../services/lottoService";
import { showNotificationTopEnd } from "../../../../util/utils";
import { DASHBOARD_LOTTOS } from "../../../../constants/AppConstants";

const { Text } = Typography;
const { Option } = Select;

export default function LottoModalStatus(props) {
    const { visible, onClose, selectedRecord = null } = props;
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    useEffect(() => {
        if (visible && selectedRecord) {
            form.setFieldsValue({
                ...selectedRecord
            });
        }
    }, [visible, selectedRecord, form]);

    const handleOk = async () => {
        setLoading(true);

        let response = await callUpdateStatusLotto(form.getFieldsValue());
        if (response?.status === 200) {
            showNotificationTopEnd("success", "Status Actualizado");
        } else if (response?.status === 400) {
            showNotificationTopEnd("error", response?.response?.data?.message);
        } else {
            showNotificationTopEnd("error", "Error al actualizar status");
        }

        setLoading(false);
        onClose();
    };

    const handleCancel = () => {
        form.resetFields();
        onClose();
    };

    return (
        <Modal
            open={visible}
            title="Actualizar Status"
            onOk={handleOk}
            onCancel={handleCancel}
            footer={[
                <Button key="back" onClick={handleCancel}>
                    Cancelar
                </Button>,
                <Button key="submit" type="primary" loading={loading} onClick={handleOk}>
                    Actualizar
                </Button>
            ]}
        >
            <Text style={{ fontSize: 15 }}>ID: </Text>
            <Text style={{ fontSize: 15 }} type="success" strong>{selectedRecord?.lottoId}</Text>
            <br />
            <Text style={{ fontSize: 15 }}>Sorteo: </Text>
            <Text style={{ fontSize: 15 }} type="success" strong>{selectedRecord?.title}</Text>
            <br />
            <br />
            <Form
                form={form}
                layout="vertical"
                name="statusForm"
            >
                <Row>
                    <Col className="px-5" xs={24} sm={12} md={12}>
                        <Form.Item label={DASHBOARD_LOTTOS.COLUMNS.ID} name="lottoId">
                            <Input disabled />
                        </Form.Item>
                    </Col>
                    <Col className="px-5" xs={24} sm={12} md={12}>
                        <Form.Item
                            name="status"
                            label="Selecciona el nuevo status"
                            rules={[{ required: true, message: 'Por favor selecciona un status' }]}
                        >
                            <Select>
                                <Option value="ACTIVE">ACTIVE</Option>
                                <Option value="CREATED">CREATED</Option>
                                <Option value="PENDING">PENDING</Option>
                                <Option value="CLOSED">CLOSED</Option>
                                <Option value="ELIMINATED">ELIMINATED</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal >
    );
}